module.exports = __webpack_public_path__ + "img/logo.e4bf9afb.svg";